var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _defs2, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyBg = function SvgSurveyBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "survey-bg_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 76 69"
    },
    viewBox: "0 0 76 69"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".survey-bg_svg__st0{fill:#ff5b00}.survey-bg_svg__st1{fill:#ff9d00}.survey-bg_svg__st2{fill:#ffd400}.survey-bg_svg__st3{fill:#b3ed00}.survey-bg_svg__st4{fill:#0feaac}.survey-bg_svg__st5{fill:#1ce3e8}.survey-bg_svg__st7{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__top_opportunity-card",
    transform: "translate(-253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__top_opportunity"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__LP-icon",
    transform: "translate(253 -52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__Group-219"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-1",
    d: "M53.2 5.9c0-3.3 2.7-5.9 5.9-5.9C62.4 0 65 2.7 65 5.9s-2.7 5.9-5.9 5.9c-3.2.1-5.9-2.6-5.9-5.9",
    className: "survey-bg_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-3",
    d: "M54.4 19.4c0-2.6 2.1-4.7 4.7-4.7s4.7 2.1 4.7 4.7-2.1 4.7-4.7 4.7-4.7-2.1-4.7-4.7",
    className: "survey-bg_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-5",
    d: "M55.4 30.9c0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8c-2.1 0-3.8-1.7-3.8-3.8",
    className: "survey-bg_svg__st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-7",
    d: "M56.4 40.7c0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7s-1.2 2.7-2.7 2.7c-1.4.1-2.7-1.2-2.7-2.7",
    className: "survey-bg_svg__st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-9",
    d: "M57.5 48.8c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6c-.8 0-1.6-.7-1.6-1.6",
    className: "survey-bg_svg__st4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-11",
    d: "M58.5 55c0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.4-.7-.7",
    className: "survey-bg_svg__st5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-13",
    d: "M35.1 11.2c-1.1-3.1.5-6.5 3.5-7.6 3.1-1.1 6.5.5 7.6 3.5 1.1 3.1-.5 6.5-3.5 7.6-3.1 1.2-6.5-.4-7.6-3.5",
    className: "survey-bg_svg__st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-15",
    d: "M40.8 23.5c-.9-2.5.4-5.2 2.8-6.1 2.5-.9 5.2.4 6.1 2.8.9 2.5-.4 5.2-2.8 6.1-2.5.9-5.2-.4-6.1-2.8",
    className: "survey-bg_svg__st1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-17",
    d: "M45.6 34c-.7-2 .3-4.1 2.3-4.9 2-.7 4.1.3 4.9 2.3.7 2-.3 4.1-2.3 4.9-2 .7-4.1-.4-4.9-2.3",
    className: "survey-bg_svg__st2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-19",
    d: "M50 42.8c-.5-1.4.2-3 1.6-3.5 1.4-.5 3 .2 3.5 1.6.5 1.4-.2 3-1.6 3.5-1.4.6-3-.2-3.5-1.6",
    className: "survey-bg_svg__st3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-21",
    d: "M53.8 50c-.3-.8.1-1.8 1-2.1.8-.3 1.8.1 2.1 1 .3.8-.1 1.8-1 2.1-.9.3-1.8-.1-2.1-1",
    className: "survey-bg_svg__st4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-23",
    d: "M56.7 55.5c-.1-.4.1-.8.4-.9.4-.1.8.1.9.4.1.4-.1.8-.4.9-.3.2-.7 0-.9-.4",
    className: "survey-bg_svg__st5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-25",
    d: "M19.9 22.4c-2.1-2.5-1.8-6.2.7-8.4s6.2-1.8 8.3.7c2.1 2.5 1.8 6.2-.7 8.4-2.5 2.1-6.2 1.8-8.3-.7",
    className: "survey-bg_svg__st0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-27",
    d: "M29.4 32c-1.7-2-1.4-5 .6-6.7 2-1.7 5-1.4 6.7.6 1.7 2 1.4 5-.6 6.7-2 1.6-5 1.4-6.7-.6",
    className: "survey-bg_svg__st1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-29",
    d: "M37.5 40.2c-1.3-1.6-1.1-4 .5-5.3 1.6-1.3 4-1.1 5.3.5 1.3 1.6 1.1 4-.5 5.3-1.5 1.3-3.9 1.1-5.3-.5",
    className: "survey-bg_svg__st2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-31",
    d: "M44.6 47c-1-1.2-.8-2.9.3-3.9 1.2-1 2.9-.8 3.8.3 1 1.2.8 2.9-.3 3.9s-2.8.9-3.8-.3",
    className: "survey-bg_svg__st3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-33",
    d: "M50.7 52.5c-.6-.7-.5-1.7.2-2.3s1.7-.5 2.3.2c.6.7.5 1.7-.2 2.3-.7.6-1.8.5-2.3-.2",
    className: "survey-bg_svg__st4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-35",
    d: "M55.3 56.6c-.3-.3-.2-.7.1-1 .3-.3.7-.2 1 .1.3.3.2.7-.1 1-.3.3-.7.2-1-.1",
    className: "survey-bg_svg__st5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-37",
    d: "M9.4 38.2c-2.8-1.6-3.8-5.3-2.2-8.1 1.6-2.8 5.3-3.8 8.1-2.2 2.8 1.6 3.8 5.3 2.2 8.1-1.7 2.8-5.3 3.8-8.1 2.2",
    className: "survey-bg_svg__st0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-39",
    d: "M21.6 43.9c-2.3-1.3-3-4.2-1.7-6.5s4.2-3 6.5-1.7 3 4.2 1.7 6.5c-1.3 2.2-4.2 3-6.5 1.7",
    className: "survey-bg_svg__st1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-41",
    d: "M32 48.8c-1.8-1-2.4-3.4-1.4-5.2 1-1.8 3.4-2.4 5.2-1.4 1.8 1 2.4 3.4 1.4 5.2-1 1.8-3.3 2.4-5.2 1.4",
    className: "survey-bg_svg__st2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-43",
    d: "M41.1 52.8c-1.3-.8-1.8-2.4-1-3.7.8-1.3 2.4-1.8 3.7-1 1.3.8 1.8 2.4 1 3.7-.8 1.3-2.4 1.7-3.7 1",
    className: "survey-bg_svg__st3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-45",
    d: "M48.6 55.9c-.8-.4-1-1.4-.6-2.2.4-.8 1.4-1 2.2-.6.8.4 1 1.4.6 2.2-.4.7-1.4 1-2.2.6",
    className: "survey-bg_svg__st4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-47",
    d: "M54.4 58.1c-.3-.2-.5-.6-.3-1 .2-.3.6-.5 1-.3.3.2.5.6.3 1-.3.4-.7.5-1 .3",
    className: "survey-bg_svg__st5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__Group-51",
    transform: "translate(0 44.091)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "survey-bg_svg__Adobe_OpacityMaskFilter",
    width: 11.8,
    height: 11.9,
    x: 0,
    y: 0.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "survey-bg_svg__mask-2",
    width: 11.8,
    height: 11.9,
    x: 0,
    y: 0.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#survey-bg_svg__Adobe_OpacityMaskFilter)"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__path-1",
    d: "M0 .7h11.8v11.8H0z",
    className: "survey-bg_svg__st7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-49",
    d: "M4.9 12.4C1.7 11.8-.5 8.8.1 5.5S3.7.1 7 .7c3.2.6 5.4 3.6 4.8 6.9-.6 3.3-3.7 5.4-6.9 4.8",
    style: {
      mask: "url(#survey-bg_svg__mask-2)",
      fill: "#ff5b00"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-52",
    d: "M18.3 57.7c-2.6-.5-4.3-2.9-3.8-5.5s2.9-4.3 5.5-3.8 4.3 2.9 3.8 5.5c-.4 2.5-2.9 4.3-5.5 3.8",
    className: "survey-bg_svg__st1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-54",
    d: "M29.8 58.8c-2.1-.4-3.4-2.3-3.1-4.4.4-2.1 2.3-3.4 4.4-3.1 2.1.4 3.4 2.3 3.1 4.4-.4 2.1-2.3 3.4-4.4 3.1",
    className: "survey-bg_svg__st2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-56",
    d: "M39.6 59.4c-1.5-.3-2.5-1.7-2.2-3.2.3-1.5 1.7-2.5 3.2-2.2 1.5.3 2.5 1.7 2.2 3.2s-1.7 2.5-3.2 2.2",
    className: "survey-bg_svg__st3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-58",
    d: "M47.8 59.7c-.9-.2-1.5-1-1.3-1.9.2-.9 1-1.5 1.9-1.3.9.2 1.5 1 1.3 1.9-.2.9-1 1.5-1.9 1.3",
    className: "survey-bg_svg__st4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-60",
    d: "M54 59.9c-.4-.1-.6-.4-.6-.8.1-.4.4-.6.8-.6.4.1.6.4.6.8-.1.4-.4.7-.8.6",
    className: "survey-bg_svg__st5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-62",
    d: "M6.9 75.3c-3.2.6-6.3-1.6-6.9-4.8-.6-3.2 1.6-6.3 4.8-6.9 3.2-.6 6.3 1.6 6.9 4.8.6 3.3-1.5 6.4-4.8 6.9",
    className: "survey-bg_svg__st0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-64",
    d: "M20 71.8c-2.6.5-5-1.3-5.5-3.8-.5-2.6 1.3-5 3.8-5.5 2.6-.5 5 1.3 5.5 3.8.5 2.6-1.3 5.1-3.8 5.5",
    className: "survey-bg_svg__st1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-66",
    d: "M31.1 68.9c-2.1.4-4-1-4.4-3.1-.4-2.1 1-4 3.1-4.4 2.1-.4 4 1 4.4 3.1.4 2.1-1 4-3.1 4.4",
    className: "survey-bg_svg__st2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-68",
    d: "M40.6 66.2c-1.5.3-2.9-.7-3.2-2.2-.3-1.5.7-2.9 2.2-3.2 1.5-.3 2.9.7 3.2 2.2s-.7 2.9-2.2 3.2",
    className: "survey-bg_svg__st3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-70",
    d: "M48.3 63.7c-.9.2-1.7-.4-1.9-1.3-.2-.9.4-1.7 1.3-1.9.9-.2 1.7.4 1.9 1.3.2.9-.4 1.7-1.3 1.9",
    className: "survey-bg_svg__st4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-72",
    d: "M54.2 61.7c-.4.1-.8-.2-.8-.6-.1-.4.2-.8.6-.8.4-.1.8.2.8.6.1.4-.2.7-.6.8",
    className: "survey-bg_svg__st5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-74",
    d: "M15.3 92.3c-2.8 1.7-6.5.7-8.1-2.1-1.6-2.8-.7-6.5 2.2-8.1 2.8-1.6 6.4-.7 8.1 2.2 1.6 2.8.6 6.4-2.2 8",
    className: "survey-bg_svg__st0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-76",
    d: "M26.3 84.6c-2.3 1.3-5.2.5-6.5-1.7-1.3-2.3-.5-5.2 1.7-6.5 2.3-1.3 5.2-.5 6.5 1.7 1.4 2.3.6 5.2-1.7 6.5",
    className: "survey-bg_svg__st1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-78",
    d: "M35.8 78c-1.8 1-4.1.4-5.2-1.4-1-1.8-.4-4.1 1.4-5.2 1.8-1 4.1-.4 5.2 1.4 1.1 1.8.4 4.1-1.4 5.2",
    className: "survey-bg_svg__st2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-80",
    d: "M43.8 72.2c-1.3.8-3 .3-3.7-1-.8-1.3-.3-3 1-3.7 1.3-.8 3-.3 3.7 1s.3 2.9-1 3.7",
    className: "survey-bg_svg__st3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-82",
    d: "M50.2 67.2c-.8.4-1.8.2-2.2-.6-.4-.8-.2-1.8.6-2.2.8-.4 1.8-.2 2.2.6.4.7.2 1.7-.6 2.2",
    className: "survey-bg_svg__st4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-84",
    d: "M55.1 63.3c-.3.2-.8.1-1-.3-.2-.3-.1-.8.3-1 .3-.2.8-.1 1 .3s0 .8-.3 1",
    className: "survey-bg_svg__st5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-86",
    d: "M28.9 105.4c-2.1 2.5-5.8 2.8-8.3.7s-2.8-5.8-.7-8.4c2.1-2.5 5.8-2.8 8.3-.7 2.5 2.2 2.9 5.9.7 8.4",
    className: "survey-bg_svg__st0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-88",
    d: "M36.7 94.3c-1.7 2-4.7 2.3-6.7.6-2-1.7-2.3-4.7-.6-6.7 1.7-2 4.7-2.3 6.7-.6 2 1.7 2.3 4.7.6 6.7",
    className: "survey-bg_svg__st1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-90",
    d: "M43.3 84.9c-1.3 1.6-3.7 1.8-5.3.5-1.6-1.3-1.8-3.7-.5-5.3 1.3-1.6 3.7-1.8 5.3-.5 1.7 1.3 1.9 3.7.5 5.3",
    className: "survey-bg_svg__st2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-92",
    d: "M48.8 76.7c-1 1.2-2.7 1.3-3.8.3-1.2-1-1.3-2.7-.3-3.9 1-1.2 2.7-1.3 3.8-.3 1.2 1 1.3 2.7.3 3.9",
    className: "survey-bg_svg__st3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-94",
    d: "M53.2 69.8c-.6.7-1.6.8-2.3.2-.7-.6-.8-1.6-.2-2.3.6-.7 1.6-.8 2.3-.2.7.6.7 1.6.2 2.3",
    className: "survey-bg_svg__st4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-96",
    d: "M56.4 64.5c-.3.3-.7.3-1 .1-.3-.3-.3-.7-.1-1 .3-.3.7-.3 1-.1.3.2.4.7.1 1",
    className: "survey-bg_svg__st5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-98",
    d: "M46.2 113c-1.1 3.1-4.5 4.7-7.6 3.5-3.1-1.1-4.7-4.5-3.5-7.6 1.1-3.1 4.5-4.7 7.6-3.5 3.1 1.1 4.7 4.6 3.5 7.6",
    className: "survey-bg_svg__st0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-100",
    d: "M49.7 100c-.9 2.5-3.6 3.7-6.1 2.8-2.5-.9-3.7-3.6-2.8-6.1.9-2.5 3.6-3.7 6.1-2.8 2.5.9 3.7 3.6 2.8 6.1",
    className: "survey-bg_svg__st1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-102",
    d: "M52.8 88.8c-.7 2-2.9 3-4.9 2.3-2-.7-3-2.9-2.3-4.9.7-2 2.9-3 4.9-2.3 2 .8 3 3 2.3 4.9",
    className: "survey-bg_svg__st2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-104",
    d: "M55.1 79.2c-.5 1.4-2.1 2.2-3.5 1.6-1.4-.5-2.1-2.1-1.6-3.5s2.1-2.2 3.5-1.6c1.4.6 2.1 2.1 1.6 3.5",
    className: "survey-bg_svg__st3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-106",
    d: "M56.8 71.3c-.3.8-1.2 1.3-2.1 1-.8-.3-1.3-1.2-1-2.1.3-.8 1.2-1.3 2.1-1 .9.3 1.3 1.2 1 2.1",
    className: "survey-bg_svg__st4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-108",
    d: "M58.1 65.2c-.1.4-.5.6-.9.4-.4-.1-.6-.5-.4-.9.1-.4.5-.6.9-.4.3.1.5.5.4.9",
    className: "survey-bg_svg__st5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-110",
    d: "M65.1 114.3c0 3.3-2.7 5.9-5.9 5.9-3.3 0-5.9-2.7-5.9-5.9 0-3.3 2.7-5.9 5.9-5.9 3.2-.1 5.9 2.6 5.9 5.9",
    className: "survey-bg_svg__st0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-112",
    d: "M63.9 100.8c0 2.6-2.1 4.7-4.7 4.7s-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7 4.7 2.1 4.7 4.7",
    className: "survey-bg_svg__st1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-114",
    d: "M63 89.3c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8",
    className: "survey-bg_svg__st2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-116",
    d: "M61.9 79.5c0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7s1.2-2.7 2.7-2.7c1.5-.1 2.7 1.2 2.7 2.7",
    className: "survey-bg_svg__st3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-118",
    d: "M60.8 71.4c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6",
    className: "survey-bg_svg__st4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-120",
    d: "M59.9 65.2c0 .4-.3.7-.7.7s-.7-.3-.7-.7c0-.4.3-.7.7-.7s.7.3.7.7",
    className: "survey-bg_svg__st5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-122",
    d: "M83.2 109c1.1 3.1-.5 6.5-3.5 7.6-3.1 1.1-6.5-.5-7.6-3.5-1.1-3.1.5-6.5 3.5-7.6 3.1-1.2 6.5.4 7.6 3.5",
    className: "survey-bg_svg__st0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-124",
    d: "M77.5 96.7c.9 2.5-.4 5.2-2.8 6.1-2.5.9-5.2-.4-6.1-2.8-.9-2.5.4-5.2 2.8-6.1 2.5-.9 5.2.4 6.1 2.8",
    className: "survey-bg_svg__st1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-126",
    d: "M72.7 86.2c.7 2-.3 4.1-2.3 4.9-2 .7-4.1-.3-4.9-2.3-.7-2 .3-4.1 2.3-4.9 2-.7 4.2.4 4.9 2.3",
    className: "survey-bg_svg__st2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-128",
    d: "M68.3 77.4c.5 1.4-.2 3-1.6 3.5-1.4.5-3-.2-3.5-1.6-.5-1.4.2-3 1.6-3.5 1.5-.6 3 .1 3.5 1.6",
    className: "survey-bg_svg__st3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-130",
    d: "M64.5 70.2c.3.8-.1 1.8-1 2.1-.8.3-1.8-.1-2.1-1-.3-.8.1-1.8 1-2.1.9-.3 1.8.1 2.1 1",
    className: "survey-bg_svg__st4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-132",
    d: "M61.6 64.7c.1.4-.1.8-.4.9-.4.1-.8-.1-.9-.4-.1-.4.1-.8.4-.9.3-.2.7 0 .9.4",
    className: "survey-bg_svg__st5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-134",
    d: "M98.5 97.8c2.1 2.5 1.8 6.2-.7 8.4-2.5 2.1-6.2 1.8-8.3-.7-2.1-2.5-1.8-6.2.7-8.4 2.4-2.2 6.1-1.8 8.3.7",
    className: "survey-bg_svg__st0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-136",
    d: "M88.9 88.2c1.7 2 1.4 5-.6 6.7-2 1.7-5 1.4-6.7-.6-1.7-2-1.4-5 .6-6.7 2-1.6 5-1.4 6.7.6",
    className: "survey-bg_svg__st1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-138",
    d: "M80.8 80c1.3 1.6 1.1 4-.5 5.3-1.6 1.3-4 1.1-5.3-.5-1.3-1.6-1.1-4 .5-5.3 1.6-1.3 3.9-1.1 5.3.5",
    className: "survey-bg_svg__st2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-140",
    d: "M73.7 73.2c1 1.2.8 2.9-.3 3.9-1.2 1-2.9.8-3.8-.3-1-1.2-.8-2.9.3-3.9s2.8-.9 3.8.3",
    className: "survey-bg_svg__st3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-142",
    d: "M67.6 67.7c.6.7.5 1.7-.2 2.3-.7.6-1.7.5-2.3-.2s-.5-1.7.2-2.3c.8-.6 1.8-.5 2.3.2",
    className: "survey-bg_svg__st4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-144",
    d: "M63 63.6c.3.3.2.7-.1 1-.3.3-.7.2-1-.1-.3-.3-.2-.7.1-1 .3-.3.7-.2 1 .1",
    className: "survey-bg_svg__st5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-146",
    d: "M108.9 82c2.8 1.6 3.8 5.3 2.2 8.1-1.6 2.8-5.3 3.8-8.1 2.2-2.8-1.6-3.8-5.3-2.2-8.1 1.7-2.8 5.3-3.8 8.1-2.2",
    className: "survey-bg_svg__st0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-148",
    d: "M96.7 76.3c2.3 1.3 3 4.2 1.7 6.5s-4.2 3-6.5 1.7-3-4.2-1.7-6.5c1.3-2.2 4.2-3 6.5-1.7",
    className: "survey-bg_svg__st1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-150",
    d: "M86.3 71.4c1.8 1 2.4 3.4 1.4 5.2-1 1.8-3.4 2.4-5.2 1.4-1.8-1-2.4-3.4-1.4-5.2 1-1.8 3.4-2.5 5.2-1.4",
    className: "survey-bg_svg__st2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-152",
    d: "M77.3 67.4c1.3.8 1.8 2.4 1 3.7-.8 1.3-2.4 1.8-3.7 1-1.3-.8-1.8-2.4-1-3.7.7-1.3 2.4-1.7 3.7-1",
    className: "survey-bg_svg__st3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-154",
    d: "M69.7 64.3c.8.4 1 1.4.6 2.2-.4.8-1.4 1-2.2.6-.8-.4-1-1.4-.6-2.2.5-.7 1.4-1 2.2-.6",
    className: "survey-bg_svg__st4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-156",
    d: "M63.9 62c.3.2.5.6.3 1-.2.3-.6.5-1 .3-.3-.2-.5-.6-.3-1 .3-.3.7-.5 1-.3",
    className: "survey-bg_svg__st5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "survey-bg_svg__Group-160",
    transform: "translate(106.185 63.347)"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "survey-bg_svg__Adobe_OpacityMaskFilter_1_",
    width: 11.8,
    height: 11.9,
    x: 0.3,
    y: 0.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "survey-bg_svg__mask-4",
    width: 11.8,
    height: 11.9,
    x: 0.3,
    y: 0.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#survey-bg_svg__Adobe_OpacityMaskFilter_1_)"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__path-3",
    d: "M.3.2h11.8v11.9H.3z",
    className: "survey-bg_svg__st7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-158",
    d: "M7.2.3C10.5.9 12.6 4 12 7.2c-.6 3.2-3.6 5.4-6.9 4.8C2 11.4-.2 8.3.4 5.1 1 1.9 4-.3 7.2.3",
    style: {
      mask: "url(#survey-bg_svg__mask-4)",
      fill: "#ff5b00"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-161",
    d: "M100 62.5c2.6.5 4.3 2.9 3.8 5.5s-2.9 4.3-5.5 3.8-4.3-2.9-3.8-5.5c.5-2.5 2.9-4.3 5.5-3.8",
    className: "survey-bg_svg__st1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-163",
    d: "M88.5 61.4c2.1.4 3.4 2.3 3.1 4.4-.4 2.1-2.3 3.4-4.4 3.1-2.1-.4-3.4-2.3-3.1-4.4.4-2.1 2.3-3.4 4.4-3.1",
    className: "survey-bg_svg__st2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-165",
    d: "M78.7 60.8c1.5.3 2.5 1.7 2.2 3.2s-1.7 2.5-3.2 2.2c-1.5-.3-2.5-1.7-2.2-3.2.3-1.5 1.7-2.5 3.2-2.2",
    className: "survey-bg_svg__st3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-167",
    d: "M70.5 60.5c.9.2 1.5 1 1.3 1.9-.2.9-1 1.5-1.9 1.3-.9-.2-1.5-1-1.3-1.9.2-.9 1.1-1.5 1.9-1.3",
    className: "survey-bg_svg__st4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-169",
    d: "M64.3 60.3c.4.1.6.4.6.8-.1.4-.4.6-.8.6-.4-.1-.6-.4-.6-.8.1-.4.4-.7.8-.6",
    className: "survey-bg_svg__st5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-171",
    d: "M111.4 44.8c3.2-.6 6.3 1.6 6.9 4.8.6 3.2-1.6 6.3-4.8 6.9-3.2.6-6.3-1.6-6.9-4.8-.6-3.2 1.6-6.3 4.8-6.9",
    className: "survey-bg_svg__st0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-173",
    d: "M98.3 48.3c2.6-.5 5 1.3 5.5 3.8.5 2.6-1.3 5-3.8 5.5-2.6.5-5-1.3-5.5-3.8-.4-2.5 1.3-5 3.8-5.5",
    className: "survey-bg_svg__st1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-175",
    d: "M87.2 51.3c2.1-.4 4 1 4.4 3.1.4 2.1-1 4-3.1 4.4-2.1.4-4-1-4.4-3.1-.4-2.1 1-4.1 3.1-4.4",
    className: "survey-bg_svg__st2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-177",
    d: "M77.7 54c1.5-.3 2.9.7 3.2 2.2.3 1.5-.7 2.9-2.2 3.2-1.5.3-2.9-.7-3.2-2.2-.3-1.5.7-2.9 2.2-3.2",
    className: "survey-bg_svg__st3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-179",
    d: "M70 56.5c.9-.2 1.7.4 1.9 1.3.2.9-.4 1.7-1.3 1.9-.9.2-1.7-.4-1.9-1.3-.2-.9.4-1.7 1.3-1.9",
    className: "survey-bg_svg__st4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-181",
    d: "M64.1 58.5c.4-.1.8.2.8.6.1.4-.2.8-.6.8-.4.1-.8-.2-.8-.6-.1-.4.2-.7.6-.8",
    className: "survey-bg_svg__st5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-183",
    d: "M103 27.9c2.8-1.6 6.5-.7 8.1 2.2 1.6 2.8.7 6.5-2.2 8.1-2.8 1.6-6.5.7-8.1-2.2-1.6-2.9-.6-6.5 2.2-8.1",
    className: "survey-bg_svg__st0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-185",
    d: "M92 35.6c2.3-1.3 5.2-.5 6.5 1.7 1.3 2.3.5 5.2-1.7 6.5-2.3 1.3-5.2.5-6.5-1.7-1.4-2.3-.6-5.2 1.7-6.5",
    className: "survey-bg_svg__st1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-187",
    d: "M82.5 42.2c1.8-1 4.1-.4 5.2 1.4 1 1.8.4 4.1-1.4 5.2-1.8 1-4.1.4-5.2-1.4-1-1.8-.4-4.2 1.4-5.2",
    className: "survey-bg_svg__st2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-189",
    d: "M74.5 48c1.3-.8 3-.3 3.7 1 .8 1.3.3 3-1 3.7-1.3.8-3 .3-3.7-1-.7-1.3-.3-2.9 1-3.7",
    className: "survey-bg_svg__st3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-191",
    d: "M68.1 53c.8-.4 1.8-.2 2.2.6.4.8.2 1.8-.6 2.2-.7.5-1.7.2-2.2-.6-.4-.7-.2-1.7.6-2.2",
    className: "survey-bg_svg__st4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-193",
    d: "M63.2 56.9c.3-.2.8-.1 1 .3.2.3.1.8-.3 1-.3.2-.8.1-1-.3-.1-.4 0-.8.3-1",
    className: "survey-bg_svg__st5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-195",
    d: "M89.4 14.8c2.1-2.5 5.8-2.8 8.3-.7 2.5 2.1 2.8 5.8.7 8.4-2.1 2.5-5.8 2.8-8.3.7-2.5-2.2-2.8-5.9-.7-8.4",
    className: "survey-bg_svg__st0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-197",
    d: "M81.6 25.9c1.7-2 4.7-2.3 6.7-.6 2 1.7 2.3 4.7.6 6.7-1.7 2-4.7 2.3-6.7.6-2-1.7-2.2-4.7-.6-6.7",
    className: "survey-bg_svg__st1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-199",
    d: "M75 35.3c1.3-1.6 3.7-1.8 5.3-.5 1.6 1.3 1.8 3.7.5 5.3-1.3 1.6-3.7 1.8-5.3.5-1.7-1.3-1.9-3.7-.5-5.3",
    className: "survey-bg_svg__st2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-201",
    d: "M69.5 43.5c1-1.2 2.7-1.3 3.8-.3 1.2 1 1.3 2.7.3 3.9-1 1.2-2.7 1.3-3.8.3-1.1-1-1.3-2.8-.3-3.9",
    className: "survey-bg_svg__st3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-203",
    d: "M65.2 50.4c.6-.7 1.6-.8 2.3-.2.7.6.8 1.6.2 2.3-.6.7-1.6.8-2.3.2s-.8-1.6-.2-2.3",
    className: "survey-bg_svg__st4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-205",
    d: "M61.9 55.7c.3-.3.7-.3 1-.1.3.3.3.7.1 1-.3.3-.7.3-1 .1-.3-.3-.4-.7-.1-1",
    className: "survey-bg_svg__st5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-207",
    d: "M72.1 7.2c1.1-3.1 4.5-4.7 7.6-3.5s4.7 4.5 3.5 7.6c-1.1 3.1-4.5 4.7-7.6 3.5-3.1-1.2-4.6-4.6-3.5-7.6",
    className: "survey-bg_svg__st0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-209",
    d: "M68.6 20.2c.9-2.5 3.6-3.7 6.1-2.8 2.5.9 3.7 3.6 2.8 6.1-.9 2.5-3.6 3.7-6.1 2.8-2.4-.9-3.7-3.6-2.8-6.1",
    className: "survey-bg_svg__st1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-211",
    d: "M65.5 31.4c.7-2 2.9-3 4.9-2.3 2 .7 3 2.9 2.3 4.9-.7 2-2.9 3-4.9 2.3-2-.8-3-3-2.3-4.9",
    className: "survey-bg_svg__st2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-213",
    d: "M63.2 40.9c.5-1.4 2.1-2.2 3.5-1.6 1.4.5 2.1 2.1 1.6 3.5s-2.1 2.2-3.5 1.6c-1.4-.5-2.1-2-1.6-3.5",
    className: "survey-bg_svg__st3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-215",
    d: "M61.5 48.9c.3-.8 1.2-1.3 2.1-1 .8.3 1.3 1.2 1 2.1-.3.8-1.2 1.3-2.1 1-.9-.3-1.3-1.2-1-2.1",
    className: "survey-bg_svg__st4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "survey-bg_svg__Fill-217",
    d: "M60.2 55c.1-.4.5-.6.9-.4.4.1.6.5.4.9-.1.4-.5.6-.9.4-.3-.1-.5-.5-.4-.9",
    className: "survey-bg_svg__st5"
  })))))))));
};
export default SvgSurveyBg;